import { render, staticRenderFns } from "./AtendimentoView.vue?vue&type=template&id=3149b663&scoped=true"
import script from "./AtendimentoView.vue?vue&type=script&lang=js"
export * from "./AtendimentoView.vue?vue&type=script&lang=js"
import style0 from "./AtendimentoView.vue?vue&type=style&index=0&id=3149b663&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3149b663",
  null
  
)

export default component.exports